/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CreatingInputs */

const th_creating = /** @type {(inputs: CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังสร้าง…`)
};

const en_creating = /** @type {(inputs: CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating…`)
};

const ja_creating = /** @type {(inputs: CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成しています…`)
};

const zh_creating = /** @type {(inputs: CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在创建…`)
};

const es_creating = /** @type {(inputs: CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creando…`)
};

const pt_creating = /** @type {(inputs: CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criando…`)
};

const id_creating = /** @type {(inputs: CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membuat…`)
};

const fr_creating = /** @type {(inputs: CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Création…`)
};

const tl_creating = /** @type {(inputs: CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ginagawa…`)
};

const vi_creating = /** @type {(inputs: CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tạo…`)
};

const ko_creating = /** @type {(inputs: CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`만드는 중…`)
};

const de_creating = /** @type {(inputs: CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird angelegt…`)
};

const ru_creating = /** @type {(inputs: CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создаём…`)
};

const tr_creating = /** @type {(inputs: CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oluşturuluyor…`)
};

const it_creating = /** @type {(inputs: CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creazione in corso…`)
};

const pl_creating = /** @type {(inputs: CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tworzenie…`)
};

const uk_creating = /** @type {(inputs: CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Створюємо…`)
};

const hi_creating = /** @type {(inputs: CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बनाया जा रहा है…`)
};

const ar_creating = /** @type {(inputs: CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ الإنشاء…`)
};

const ms_creating = /** @type {(inputs: CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedang mencipta…`)
};

const bn_creating = /** @type {(inputs: CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`তৈরি হচ্ছে…`)
};

const zh_tw2_creating = /** @type {(inputs: CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建立中…`)
};

const zh_hk2_creating = /** @type {(inputs: CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建立中…`)
};

const ur_creating = /** @type {(inputs: CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بنایا جا رہا ہے…`)
};

const fa_creating = /** @type {(inputs: CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`در حال ساختن…`)
};

const sw_creating = /** @type {(inputs: CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inafunguliwa…`)
};

const nl_creating = /** @type {(inputs: CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezig met aanmaken…`)
};

/**
* | output |
* | --- |
* | "Creating…" |
*
* @param {CreatingInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const creating = /** @type {((inputs?: CreatingInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CreatingInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_creating(inputs)
	if (locale === "ja") return ja_creating(inputs)
	if (locale === "zh") return zh_creating(inputs)
	if (locale === "es") return es_creating(inputs)
	if (locale === "pt") return pt_creating(inputs)
	if (locale === "id") return id_creating(inputs)
	if (locale === "fr") return fr_creating(inputs)
	if (locale === "tl") return tl_creating(inputs)
	if (locale === "vi") return vi_creating(inputs)
	if (locale === "ko") return ko_creating(inputs)
	if (locale === "de") return de_creating(inputs)
	if (locale === "ru") return ru_creating(inputs)
	if (locale === "tr") return tr_creating(inputs)
	if (locale === "it") return it_creating(inputs)
	if (locale === "pl") return pl_creating(inputs)
	if (locale === "uk") return uk_creating(inputs)
	if (locale === "hi") return hi_creating(inputs)
	if (locale === "ar") return ar_creating(inputs)
	if (locale === "ms") return ms_creating(inputs)
	if (locale === "bn") return bn_creating(inputs)
	if (locale === "zh-TW") return zh_tw2_creating(inputs)
	if (locale === "zh-HK") return zh_hk2_creating(inputs)
	if (locale === "ur") return ur_creating(inputs)
	if (locale === "fa") return fa_creating(inputs)
	if (locale === "sw") return sw_creating(inputs)
	if (locale === "nl") return nl_creating(inputs)
	return en_creating(inputs)
});